(function () {
    'use strict';

    angular.module('Authentication')
        .factory('AuthenticationService', function (
            Base64,
            $http,
            $cookies,
            $httpParamSerializerJQLike,
            RememberMeService
        ) {
            return {
                Login: function (username, password, callback, requestMethod) {
                    var data = {
                        'client_id': authParams['client_id']
                    };
                    switch (requestMethod || 'auth') {
                        case 'auth':
                            data['username'] = username;
                            data['password'] = password;
                            data['grant_type'] = 'password';
                            data['client_secret'] = authParams['client_secret'];
                            break;
                        case 'refresh':
                            var refresh_token = $cookies.get('auth') ? $cookies.get('auth') : localStorage.getItem('auth');
                            var resellerId = $cookies.get('resellerId') || undefined;
                            refresh_token = refresh_token || false;
                            data['grant_type'] = 'refresh_token';
                            data['refresh_token'] = refresh_token;
                            data['reseller_id'] = resellerId;
                            break;
                    }
                    $http({
                        url: authURL,
                        traditional: true,
                        method: 'POST',
                        data: data,
                        headers: {
                            'Authorization': 'Basic ' + Base64.encode(authParams['client_id'] + ":" + authParams['client_secret']),
                            'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                        },
                        transformRequest: $httpParamSerializerJQLike
                    }).then(function (response) {
                        var cookieOptions = {
                            expires: new Date((new Date()).getTime() + response['data']['expires_in'] * 1000),
                            path: '/'
                        };
                        $cookies.put('auth', response['data']['refresh_token'], cookieOptions);
                        $cookies.put('resellerId', data['reseller_id'], cookieOptions);
                        $cookies.put('access_token', response['data']['access_token']);
                        $http.defaults.headers.common.Authorization = 'Bearer ' + response['data']['access_token'];
                        callback(response);
                    }, function (response) {
                        callback(response);
                    });
                },
                ClearCredentials: function () {
                    $cookies.remove('resellerId');
                    $cookies.remove('auth', {
                        path: '/'
                    });
                    localStorage.removeItem('auth');
                    localStorage.removeItem('c_td');
                    $cookies.remove('isAgreedTerm');
                    $http.defaults.headers.common.Authorization = '';
                },
                passwordReset: function (data, successCallback, errorCallback) {
                    $http({
                        url: ApiURLs.user.resetPassword + '?email=' + data.email + '&reseller_id=' + (data.resellerId) + '&client_id=' + data.clientId,
                        method: 'POST'
                    }).then(function (response) {
                        successCallback ? successCallback(response) : false;
                    }, function (response) {
                        errorCallback ? errorCallback(response) : false;
                    });
                },
                acceptTerms: function (successCallback, errorCallback) {
                    $http({
                        url: ApiURLs.terms.admin,
                        method: 'PUT',
                    }).then(function (response) {
                        successCallback(response);
                    }, function (response) {
                        errorCallback(response);
                    });
                },
                loginUsingRememberMeToken: function (successCallback, errorCallback) {
                    var data = {
                        'client_id': authParams['client_id'],
                        'grant_type': 'refresh_token',
                        'refresh_token': RememberMeService.getRememberMeTokens() || false,
                        'reseller_id': $cookies.get('resellerId') || undefined
                    };

                    $http({
                        url: authURL,
                        traditional: true,
                        method: 'POST',
                        data: data,
                        headers: {
                            'Authorization': 'Basic ' + Base64.encode(authParams['client_id'] + ":" + authParams['client_secret']),
                            'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                        },
                        transformRequest: $httpParamSerializerJQLike
                    }).then(function (response) {
                        var cookieOptions = {
                            expires: new Date((new Date()).getTime() + response['data']['expires_in'] * 1000),
                            path: '/'
                        };

                        $cookies.put('auth', response['data']['refresh_token'], cookieOptions);
                        $cookies.put('resellerId', data['reseller_id'], cookieOptions);
                        $cookies.put('access_token', response['data']['access_token']);

                        $http.defaults.headers.common.Authorization = 'Bearer ' + response['data']['access_token'];
                        successCallback(response);
                    }, function (response) {
                        errorCallback(response);
                    });
                },
                refreshToken: function (successCallback, errorCallback) {
                    const data = { 'client_id': authParams['client_id'] };
                    const resellerId = $cookies.get('resellerId') || undefined;

                    let refresh_token = $cookies.get('auth') ? $cookies.get('auth') : sessionStorage.getItem('auth');
                    refresh_token = refresh_token || false;

                    data['grant_type'] = 'refresh_token';
                    data['refresh_token'] = refresh_token;
                    data['reseller_id'] = resellerId;

                    $http({
                        url: authURL,
                        traditional: true,
                        method: 'POST',
                        data: data,
                        headers: {
                            'Authorization': 'Basic ' + $base64.encode(authParams['client_id'] + ":" + authParams['client_secret']),
                            'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                        },
                        transformRequest: $httpParamSerializerJQLike
                    }).then(response => {
                        const cookieOptions = {
                            expires: new Date((new Date()).getTime() + response['data']['expires_in'] * 1000),
                            path: '/'
                        };

                        localStorage.setItem('c_td', angular.toJson(response));
                        $cookies.put('auth', response['data']['refresh_token'], cookieOptions);
                        $cookies.put('resellerId', data['reseller_id'], cookieOptions);
                        $cookies.put('access_token', response['data']['access_token']);
                        $http.defaults.headers.common.Authorization = 'Bearer ' + response['data']['access_token'];
                        successCallback(response);
                    }, error => {
                        errorCallback(error);
                    });
                }
            };
        });
})();


// WEBPACK FOOTER //
// ./js/services/authentication.js